import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//扣费规则
export function cancelPricingDetails(data) {
    return fetch({
        url: config.WEB_CANCELPROCINGDETAILS_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//扣费规则
export function timeOutPricingDetails(data) {
    return fetch({
        url: config.WEB_TIMEOUTPRICINGDETAILS_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

// 行驶证认证
export function ocrVehicleLicense(data) {
    return fetch({
        url: config.WEB_OCR_VEHICLE_LICENSE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
